/**
 * Closing all nestings offcanvasses inside main menu
 * + dynamic margins for submenus based on headers height
 */

export default (() => {
  const offcanvasMenus = document.querySelectorAll('.offcanvas-categories')

  if (!offcanvasMenus.length) return

  offcanvasMenus.forEach((menu) => {
    const headers = menu.querySelectorAll('.offcanvas-header')
    const firstHeader = headers[0]
    const lastHeader = headers[headers.length - 1]

    const setSubmenuOffsets = () => {
      const topOffset = firstHeader ? firstHeader.offsetHeight : 0
      const bottomOffset = lastHeader ? lastHeader.offsetHeight : 0

      const submenus = menu.querySelectorAll('.offcanvas-submenu')

      submenus.forEach((submenu) => {
        submenu.style.marginTop = `${topOffset + 1}px`
        submenu.style.marginBottom = `${bottomOffset + 1}px`
      })
    }
    setSubmenuOffsets()
    window.addEventListener('resize', setSubmenuOffsets)
    menu.addEventListener('hide.bs.offcanvas', () => {
      const submenus = menu.querySelectorAll('.offcanvas-submenu')

      submenus.forEach((submenu) => {
        submenu.classList.remove('offcanvas-show')
      })
    })
  })
})()
